import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const HeaderFooterWidgetContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: -webkit-fill-available;
  height: 100%;
  z-index: 1;
  background-color: ${RETAILER_COLORS.secondary['100']};
  box-shadow: ${SHADOWS.xl};
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const HeaderStub = styled.div`
  position: sticky;
  top: 0;
  height: 1px;
  background: ${RETAILER_COLORS.secondary['100']};
  z-index: 9999;
  pointer-events: none;
`;

export const BodyContainer = styled(Flexbox)<{ $isFixedBody: boolean }>`
  flex: 1;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  scrollbar-width: none;

  ${({ $isFixedBody }) =>
    $isFixedBody &&
    `overflow-y: hidden;
  }`}
`;

export const FooterWidgetAnonymousWrapper = styled.div`
  margin-top: auto;
`;

export const FooterContent = styled(Flexbox)`
  margin: -2px 0;
  background-color: ${RETAILER_COLORS.primary['800']};
`;

export const ExternalFooterWrapper = styled.div`
  margin-top: auto;
`;
